import React from "react";

const ModalPagamentos = ({result, data, onClose }) => {
  if (!data) return null;
  console.log(data);

  const formatDateISOtoDMY = (isoDate) => {
    const date = new Date(isoDate); 
    
    if (isNaN(date)) return ''; 
    
    const day = date.getDate().toString().padStart(2, '0'); 
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear(); 
    
    return `${day}/${month}/${year}`; 
  };
  

  return (
    <div
  className="modal fade show"
  style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
>
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Dados dos Pagamentos</h5>
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
        ></button>
      </div>

      {Number(result) === 0 ? (
        <div className="modal-body">
          <strong className="fs-5">Sem Dados!</strong>
          <p className="fs-5">{data.description}</p>
        </div>
      ) : Number(result) === 1 ? (
        <div className="modal-body">
          <div className="row mb-3">
            <div className="col-2">
              <label htmlFor="inputAddress" className="form-label">Codigo do Titulo</label>
              <input
                type="text"
                value={data[0].SEQ_CONTA}
                className="form-control"
                id="inputDescricao"
                tabIndex="1"
                required
                autoComplete="off"
                readOnly
              />
            </div>

            <div className="col-3">
              <label htmlFor="inputAddress" className="form-label">Codigo do Responsavel</label>
              <input
                type="text"
                value={data[0].RESPONSAVEL}
                className="form-control"
                id="inputDescricao"
                tabIndex="1"
                required
                autoComplete="off"
                readOnly
              />
            </div>
            <div className="col-7">
              <label htmlFor="inputAddress" className="form-label">Razão</label>
              <input
                type="text"
                value={data[0].RAZAO}
                className="form-control"
                id="inputCompra"
                tabIndex="2"
                required
                autoComplete="off"
                readOnly
              />
            </div>
            <div className="col-3">
              <label htmlFor="inputAddress" className="form-label">Documento</label>
              <input
                type="text"
                value={data[0].DOCUMENTO}
                className="form-control"
                id="inputCompra"
                tabIndex="2"
                required
                autoComplete="off"
                readOnly
              />
            </div>
            <div className="col-3">
              <label htmlFor="inputAddress" className="form-label">Data Emissão</label>
              <input
                type="text"
                value={data[0].DATA_EMISSAO}
                className="form-control"
                id="inputCompra"
                tabIndex="2"
                required
                autoComplete="off"
                readOnly
              />
            </div>
            <div className="col-3">
              <label htmlFor="inputAddress" className="form-label">Valor da Conta</label>
              <input
                type="text"
                value={Number(data[0].VLR_HIST).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                className="form-control"
                id="inputCompra"
                tabIndex="2"
                required
                autoComplete="off"
                readOnly
              />
            </div>
          </div>

          {/* Adicionar a tabela de dados dos pagamentos */}
          <table translate="no" id="table-prod" className="table table-hover table-striped">
            <thead>
              <tr>
                <th scope="col">Data Pagamento</th>
                <th scope="col">Juros</th>
                <th scope="col">Valor Pago</th>
                <th scope="col">Desconto</th>
                <th scope="col">Total a Pagar</th>
                <th scope="col">Finalizadora</th>
                <th scope="col">Cancelar</th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {data.map((produto) => (
                <tr key={produto.SEQ}>
                  <td>{formatDateISOtoDMY(produto.DATA_PAGAMENTO)}</td>
                  <td>{produto.JUROSMULTA.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                  <td>{produto.VLR_PAGO.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                  <td>{produto.DESCONTO.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                  <td>{produto.TOTAL_PAGAR.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                  <td>{produto.FINALIZADORA}</td>
                  <td  className="" >{}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>
  );
};

export default ModalPagamentos;
